import { ChangeEvent, FormEvent } from 'react';
import ErrorBox from './ErrorBox';
import ButtonLabel from '../atoms/ButtonLabel';
import { Button, ButtonContainer, FormWrapper } from '../atoms/EditFormContent';
import i18n from '../R/string/i18n';
import SelectForm from '../molecules/SelectForm';
import countries from '../utils/countries';
import ReceiveWamazingMail from '../molecules/ReceiveWamazingMail';

type Props = {
  location: string;
  onChangeLocation: (event: ChangeEvent<HTMLSelectElement>) => void;
  locationErr?: string;
  serverErrMsg: string;
  updateEnabled: boolean;
  onUpdateLocation: (event: FormEvent<HTMLFormElement>) => void;
  accountSettingModalOpen?: boolean;
  needReceiveEmail?: boolean;
  toggleReceiveEmail?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const UpdateLocationForm = ({
  location,
  onChangeLocation,
  locationErr,
  serverErrMsg,
  updateEnabled,
  onUpdateLocation,
  accountSettingModalOpen,
  needReceiveEmail,
  toggleReceiveEmail
}: Props) => (
  <>
    <ErrorBox message={serverErrMsg} />
    <FormWrapper onSubmit={onUpdateLocation}>
      <SelectForm
        label={i18n.location()}
        value={location}
        onChangeLocation={onChangeLocation}
        errorMessage={locationErr}
        locationList={countries()}
      />
      {accountSettingModalOpen && (
        <ReceiveWamazingMail
          needReceiveEmail={needReceiveEmail}
          toggleReceiveEmail={toggleReceiveEmail}
          marginLeft={48}
        />
      )}
      <ButtonContainer>
        <Button type="submit" disabled={updateEnabled}>
          <ButtonLabel>{i18n.commonSave()}</ButtonLabel>
        </Button>
      </ButtonContainer>
    </FormWrapper>
  </>
);

export default UpdateLocationForm;
